import type { ViewHistory } from '@pco/api/generated/graphql';
export const KEY = 'userViewHistory';

export const getViewHistory = (): ViewHistory[] => {
	const storage = localStorage.getItem(KEY);
	if (!storage) return [];
	const userViewHistory = JSON.parse(storage) as ViewHistory[];
	return userViewHistory;
};

export const addViewHistory = (sku: string) => {
	const currentDate = new Date().toISOString();
	const newViewHistoryItem: ViewHistory = {
		sku,
		date: currentDate,
	};
	let userViewHistory = getViewHistory();
	if (!userViewHistory) {
		userViewHistory = [newViewHistoryItem];
	} else {
		const existingItem = userViewHistory.find(
			(item: ViewHistory) => item.sku === newViewHistoryItem.sku,
		);
		if (existingItem) {
			existingItem.date = currentDate;
		} else {
			userViewHistory.push(newViewHistoryItem);
		}
	}
	localStorage.setItem(KEY, JSON.stringify(userViewHistory));
};
